<div class="gallery-wrapper">
    <ngx-gallery
        [options]="galleryOptions"
        [images]="galleryImages"
        class="ngx-gallery"></ngx-gallery>
</div>
